import React from 'react'
import { withRouter } from 'react-router-dom'
import { PropTypes } from 'prop-types'
import api from '../../utils/api'

class Breadcrumbs extends React.Component {
  constructor(props) {
    super(props)
    this.refreshBreadcrumbs = this.refreshBreadcrumbs.bind(this)
    const urlparts = this.props.url.split('/')
    const companiesUrl = `/${urlparts[3]}`
    this.state = { 
      crumbs: [['Companies', companiesUrl]],
      employerName: this.props.employerName,
      refresh: false
     }
  }

  componentWillMount() {
    this.refreshBreadcrumbs()
  }

  componentWillReceiveProps() {
    if(this.props.refresh && !this.state.refresh) {
      this.setState({ refresh: true }, this.refreshBreadcrumbs)
    }
    if(this.props.employerName !== this.state.employerName) {
      this.setState({ employerName: this.props.employerName, refresh: true }, this.refreshBreadcrumbs)
    }
  }

  handleBreadcrumb(e, crumb) {
    e.preventDefault()
    this.props.history.push(crumb[1])
  }

  refreshBreadcrumbs() {
    const url = this.props.url.split('/')
    const companiesUrl = `/${url[3]}`
    const empId = this.props.employerId
    const conId = this.props.contractorId
    let empName = empId === 0 ? 'Add a new company' : this.state.employerName
    const conName = conId === 0 ? 'Add a new colleague' : this.props.contractorName
    let crumbs = this.state.crumbs

    if(this.state.refresh === true) {
      crumbs = [['Companies', companiesUrl]]
      this.setState({ refresh: false })
    }

    if (empId !== null && conId === null ) {
      crumbs = crumbs.concat([[empName, `${companiesUrl}/${empId === 0 ? 'Add' : `${empId}#tab-details`}`]])
    }

    if (conId !== null && conName !== null) {
      const conPart = [conName, `${companiesUrl}/${url[4]}/${url[5]}/${url[6]}/${conId === 0 ? 'Add' : conId}`]
      if (empName === null) {             //To handle loss of currentEmployer data when Contractor page reloads
        api.getEmployerName(empId).then(data => {
          empName = data
          const empPart = [empName, `${companiesUrl}/${empId === 0 ? 'Add' : `${empId}#tab-details`}`]
          crumbs = crumbs.concat([empPart, conPart])
          this.setState({ crumbs: crumbs})
        })
      }
      else {
        const empPart = [empName, `${companiesUrl}/${empId === 0 ? 'Add' : `${empId}#tab-details`}`]
        crumbs = crumbs.concat([empPart, conPart])
      }
    }
    this.setState({ crumbs: crumbs})
  }

  render() {
    return (
      <nav className="ln-c-breadcrumbs c-breadcrumb-style">
        <ul className="ln-o-inline-list ln-o-inline-list--spaced">
          {this.state.crumbs.map((crumb, index) =>
            <li key={crumb} className="ln-o-inline-list__item">
              { index < this.state.crumbs.length - 1 ?
                <span className="ln-c-breadcrumbs__item">
                  <a href={crumb[1]} onClick={e => this.handleBreadcrumb(e, crumb)}>{crumb[0]}</a>
                </span> :
                crumb[0]
              }
            </li>
          )}
        </ul>
      </nav>
    )
  }
}

Breadcrumbs.propTypes = {
  url: PropTypes.string.isRequired,
  employerId: PropTypes.number,
  contractorId: PropTypes.number,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired,
  employerName: PropTypes.string,
  contractorName: PropTypes.string,
  refresh: PropTypes.bool
}

Breadcrumbs.defaultProps = {
  employerId: null,
  contractorId: null,
  employerName: null,
  contractorName: null,
  refresh: false
}

export default withRouter(Breadcrumbs)



// WEBPACK FOOTER //
// ./src/components/Breadcrumbs/index.jsx